import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Button, Modal } from '@monavate/ui-core';
import { BigTiles } from '../BigTiles/BigTiles';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../reduxStore/rootReducer';
import { useNavigate } from 'react-router-dom';
import { closeCreateInstructionModal } from '../../reduxStore/slices/ordersSlice';

const Wrapper = styled.div`
    margin: -20px -24px;
    background: ${(props) => props.theme['Surface/page']}
        /* TODO: check color. Alternatives: ["Surface/page","Surface/primary","Content/inverse","Content/overlay"] */;
    border-radius: 0;
`;
const Header = styled.div`
    margin-bottom: 8px;
    padding: 14px 32px;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    background: #f9fbfc /* TODO: need to change color. There is no such color in themes.ts */;
    border-bottom: 1px solid ${(props) => props.theme['Content/secondary']}
        /* TODO: check color. Alternatives: ["Content/secondary","Borders/quiet"] */;
`;
const Content = styled.div`
    margin-bottom: 8px;
    // padding: 8px 32px;
    background: ${(props) => props.theme['Surface/page']}
        /* TODO: check color. Alternatives: ["Surface/page","Surface/primary","Content/inverse","Content/overlay"] */;
`;

const Footer = styled.div`
    padding: 16px 32px;
    border-top: 1px solid ${(props) => props.theme['Content/secondary']}
        /* TODO: check color. Alternatives: ["Content/secondary","Borders/quiet"] */;
    background: #f9fbfc /* TODO: need to change color. There is no such color in themes.ts */;
    display: flex;
    justify-content: flex-end;
    gap: 16px;
`;

const Description = styled.div`
    margin-bottom: 16px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
`;

export const InitPaymentInstructionModal = ({
    isOpen,
    handleCancel,
}: {
    isOpen: boolean;
    handleCancel: () => void;
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [selected, setSelected] = useState<string>('');
    const createPaymentInstructionData = useSelector(
        (state: RootState) => state.orders.createPaymentInstructionToDisplay,
    );

    const handleContinue = () => {
        const link =
            selected === 'card'
                ? 'create-card-payment-instruction'
                : 'create-iban-payment-instruction';
        navigate(`/orders/${createPaymentInstructionData.order.reference}/${link}`, {
            state: { type: selected },
        });
        dispatch(closeCreateInstructionModal());
    };

    useEffect(() => {
        if (!isOpen) {
            setSelected('');
        }
    }, [isOpen]);

    return (
        <Modal
            dataTestId="modal-create-payment-instruction"
            width={456}
            open={isOpen}
            footer={null}
            title={'Create payment instruction'}
            onSubmit={handleContinue}
            submitTitle={'Continue'}
            disabledSubmit={!selected}
            onClose={handleCancel}
        >
            {/*<Wrapper>*/}
            {/*<Header>Create payment instruction</Header>*/}
            <Content>
                <Description>
                    Select what type of payment instruction you want to create:
                </Description>
                <BigTiles
                    handleClick={(selectedId) => {
                        setSelected(selectedId);
                    }}
                    selected={selected}
                    items={[
                        {
                            id: 'card',
                            icon: <span className="material-symbols-outlined">credit_card</span>,
                            title: 'Card',
                        },
                        {
                            id: 'iban',
                            icon: (
                                <span className="material-symbols-outlined">account_balance</span>
                            ),
                            title: 'Bank',
                        },
                    ]}
                />
            </Content>
            {/*<Footer>*/}
            {/*    <Button handleClick={handleCancel}>Cancel</Button>*/}
            {/*    <Button viewType="primary" disabled={!selected} handleClick={handleContinue}>*/}
            {/*        Continue*/}
            {/*    </Button>*/}
            {/*</Footer>*/}
            {/*</Wrapper>*/}
        </Modal>
    );
};
